import RandomPlanet from './random-planet';

export default RandomPlanet;



// WEBPACK FOOTER //
// ./src/components/random-planet/index.js